module.exports = __webpack_public_path__ + "img/1.7c6f03b6.png";